/* TopBar.jsx */
import React from "react";
import { FaTwitter, FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";

export default function TopBar() {
  return (
    <div className="topbar">
      <div className="topbar-inner container">
        <div className="topbar-left">
          {/* social icons — use <a> for real links */}
          <a className="top-social" href="#" aria-label="twitter"><FaTwitter /></a>
          <a className="top-social" href="#" aria-label="facebook"><FaFacebookF /></a>
          <a className="top-social" href="#" aria-label="instagram"><FaInstagram /></a>
          <a className="top-social" href="#" aria-label="linkedin"><FaLinkedinIn /></a>
        </div>

        <div className="topbar-right">
          <a className="top-contact" href="mailto:contact@supersteno.com">
            ✉ contact@supersteno.com
          </a>
          <span className="top-phone">📞 +91 76780 73260</span>
        </div>
      </div>
    </div>
  );
}
